import { render, staticRenderFns } from "./MassExpenseDealEdit.vue?vue&type=template&id=89118f64&"
import script from "./MassExpenseDealEdit.vue?vue&type=script&lang=js&"
export * from "./MassExpenseDealEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports